import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { LayoutModule } from './layout/layout.module';

// BUG 1 FIX: formato explícito DD/MM/YYYY para o NativeDateAdapter
export const PT_BR_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: null },
  display: {
    dateInput:          { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel:     { month: 'short', year: 'numeric' },
    dateA11yLabel:      { day: 'numeric', month: 'long',   year: 'numeric' },
    monthYearA11yLabel: { month: 'long',  year: 'numeric' },
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    LayoutModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID,        useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE,  useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: PT_BR_DATE_FORMATS },  // BUG 1 FIX
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
